import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd8304c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "AEstadoVazioTabela",
  "data-testid": "AEstadoVazioTabela"
}
const _hoisted_2 = { class: "AEstadoVazioTabela__texto" }

import { useI18n } from 'vue-i18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AEstadoVazioTabela',
  setup(__props) {

  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('nenhumResultadoEncontrado')), 1)
  ]))
}
}

})